import { render, staticRenderFns } from "./release-dialog.vue?vue&type=template&id=03b36e44&scoped=true"
import script from "./release-dialog.vue?vue&type=script&lang=js"
export * from "./release-dialog.vue?vue&type=script&lang=js"
import style0 from "./release-dialog.vue?vue&type=style&index=0&id=03b36e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b36e44",
  null
  
)

export default component.exports